var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"title-card pa-6 pa-md-10 mb-12 rounded-xl"},[_c('h2',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.title))]),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }